import React from 'react';
import AppDetailContainer from '@src/containers/AppDetail';

const AppDetail = () => <AppDetailContainer />;

export default AppDetail;
